import { render, staticRenderFns } from "./product3.vue?vue&type=template&id=748480fb&scoped=true&"
import script from "./product3.vue?vue&type=script&lang=js&"
export * from "./product3.vue?vue&type=script&lang=js&"
import style0 from "./product3.vue?vue&type=style&index=0&id=748480fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748480fb",
  null
  
)

export default component.exports